/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Meeting_Offline_StartInputs */



/**
* | output |
* | --- |
* | "Start recording" |
*
* @param {Meeting_Offline_StartInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const meeting_offline_start = /** @type {((inputs?: Meeting_Offline_StartInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Meeting_Offline_StartInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("Opname starten")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Démarrer l'enregistrement")
	return /** @type {LocalizedString} */ ("Start recording")
});